module.exports = __webpack_public_path__ + "img/lv_failure_7.709cf9af.png";